import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "../../locales/en/translation.json";
import pt_br from "../../locales/pt_br/translation.json";
import es from "../../locales/es/translation.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      "pt-BR": { translation: pt_br },
      "en-US": { translation: en },
      es: { translation: es },
    },
    //TO-DO - REMOVER O COMENTARIO DO FALLBACK QUANDO FOR PARA PRODUÇÃO
    fallbackLng: "en-US",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
